import styled from "styled-components";

export const ComponentWrapper = styled.div`
  position: relative;
`;

export const ColorPickerContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 5px;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
`;

export const ColorPickerTile = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  aspect-ratio: 1;
  border-radius: 50%;
  box-shadow: inset 0 0 1px #00000080;
  color: ${({ text }) => text};
  background: ${({ accent }) => accent};

  ${({ isSelected, theme }) => {
    if (isSelected) {
      return `
        outline: 2px solid ${theme.text.brand}4d;
        outline-offset: 1px;
      `;
    }

    return `outline:none;`;
  }}

  &:hover {
    filter: brightness(0.96);
  }
`;
